import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, CardMedia, Card, CardTitle, Typography
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import ListsHeader from '../ListsHeader';
import CreateNewList from '../CreateNewList';
import { NAVIGATION_URLS } from '../../../constants/navigationUrls';
import NullViewTexts from '../../../constants/NullViewTexts';
import { trackLearnMoreClick } from '../../../utils/analyticsHelpers';

const CompactNullView = ({
  clickID, isDashboardSnapshot
}) => {
  const {
    imageAlt, imageUrl, cardTitle, benefits, learnMoreText
  } = NullViewTexts;

  return (
    <Card
      data-component="Lists"
      data-testid="compact-null-view"
      className="sui-h-full"
      // Dashboard Snapshot: no border or header row, like the desktop view, and no inset of its own,
      // since the snapshot's panel already insets its mobile content. Learn More moves from the
      // header into a button beside Create New, keeping the header link's analytics.
      PaperProps={isDashboardSnapshot ? { variant: 'shadow', shadow: 'none' } : undefined}
      CardContentProps={{
        className: classNames(
          'sui-flex',
          'sui-flex-col',
          'sui-h-full',
          { 'sui-pt-4 sui-px-4 sui-pb-4': !isDashboardSnapshot },
          'sui-w-full'
        )
      }}
    >
      {!isDashboardSnapshot && <ListsHeader actions={['learnMore']} clickID={clickID} />}
      <div className="sui-flex sui-flex-col sui-h-full">
        <div className={isDashboardSnapshot ? 'sui-rounded-md sui-overflow-hidden' : 'sui-mt-4'}>
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            aspect="wide"
          />
        </div>
        <div
          data-testid="null-view-content"
          className="sui-flex sui-flex-col sui-mt-5"
        >
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle.join('\n')}</span>}
          />
          <div className="sui-mt-1">
            <Typography>
              {benefits.map((sentence, i) => (
                <React.Fragment key={`benefit-${i}`}>
                  {sentence}{i < benefits.length - 1 && <br />}
                </React.Fragment>
              ))}
            </Typography>
          </div>
        </div>
        <div className="sui-mt-auto sui-pt-4">
          {isDashboardSnapshot ? (
            <div className="sui-flex sui-gap-4">
              <div className="sui-flex-1">
                <Button
                  variant="secondary"
                  fullWidth
                  href={NAVIGATION_URLS.LEARN_MORE}
                  onClick={() => trackLearnMoreClick()}
                >
                  {learnMoreText}
                </Button>
              </div>
              <div className="sui-flex-1">
                <CreateNewList variant="button" />
              </div>
            </div>
          ) : (
            <CreateNewList variant="button" />
          )}
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = {
  clickID: PropTypes.string.isRequired,
  isDashboardSnapshot: PropTypes.bool
};

CompactNullView.defaultProps = {
  isDashboardSnapshot: false
};

export default CompactNullView;
